// @ts-strict-ignore
import React from 'react'
import { getDateString } from '..'
import { RichText } from '../../helpers/react'
import { markdownParser } from '../../../utils/markdown-parser'

type TableProps = {
  children: React.ReactNode
  footnotes: string
  dateString: string | null
}

export const Table = ({ children, footnotes, dateString }: TableProps) => {
  return (
    <div className='MarkdownTable'>
      <div className='MarkdownTable__tableContainer'>
        <table className='MarkdownTable__table'>
          <tbody>{children}</tbody>
        </table>
      </div>
      {dateString && <div className='MarkdownTable__date'>Date {dateString}</div>}
      {footnotes && (
        <div className='MarkdownTable__footnotes'>
          <RichText content={footnotes} />
        </div>
      )}
    </div>
  )
}

type TableRowProps = {
  children: React.ReactNode
}

export const TableRow = ({ children }: TableRowProps) => <tr>{children}</tr>

type TableCellProps = {
  children: string
  type: 'th' | 'td'
}

export const TableCell = ({ children, type }: TableCellProps) => {
  return type === 'th' ? (
    <th>{children}</th>
  ) : (
    <td dangerouslySetInnerHTML={{ __html: markdownParser(children) }} />
  )
}

type Row = {
  type: 'th' | 'td'
  value: string
  marks: any
}

type MarkdownTableProps = {
  title?: string
  contents: Row[][]
  footnotes: any
  displayDate: boolean
  localDates: Date
  globalDates: Date
}

const MarkdownTable = (props: MarkdownTableProps) => {
  const { title, contents, footnotes, displayDate, localDates, globalDates } = props
  const dateString = displayDate ? getDateString(localDates, globalDates) : null
  return (
    <div className='MarkdownTableWrapper'>
      {title && <div className='MarkdownTable__title'>{title}</div>}
      <Table footnotes={footnotes} dateString={dateString}>
        {contents.map((row, rowIndex: number) => (
          <TableRow key={rowIndex}>
            {row.map(({ type, value }, colIndex) => (
              <TableCell type={type} key={colIndex}>
                {value}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </Table>
    </div>
  )
}

export default MarkdownTable
